module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "color": "#048019"
    }
  }, [_vm._v("Aprovação da Proposta")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "cmptDocPreparationForm",
      "novalidate": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('banco')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Banco")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "banco",
      "mask": ['###']
    },
    model: {
      value: (_vm.aprovacao.ds_agencia_banco),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "ds_agencia_banco", $$v)
      },
      expression: "aprovacao.ds_agencia_banco"
    }
  }), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('banco')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('agencia')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencia",
      "mask": ['####-X']
    },
    model: {
      value: (_vm.analise.proposal.agencyNumber),
      callback: function($$v) {
        _vm.$set(_vm.analise.proposal, "agencyNumber", $$v)
      },
      expression: "analise.proposal.agencyNumber"
    }
  }), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('conta corrente')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Conta Corrente")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "conta corrente",
      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X']
    },
    model: {
      value: (_vm.aprovacao.ds_agencia_conta_corrente),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "ds_agencia_conta_corrente", $$v)
      },
      expression: "aprovacao.ds_agencia_conta_corrente"
    }
  }), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('dl', [_c('div', {
    staticClass: "form-group col-md-12 required-field-field",
    class: {
      'has-error': _vm.errors.first('data proposta')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data proposta",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.aprovacao.dt_proposta),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dt_proposta", $$v)
      },
      expression: "aprovacao.dt_proposta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data proposta')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data análise')
    },
    attrs: {
      "uib-tooltip": "Data de análise"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data análise",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "use-utc": true,
      "format": "dd/MM/yyyy",
      "placeholder": "__/__/____"
    },
    model: {
      value: (_vm.aprovacao.dt_analise),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dt_analise", $$v)
      },
      expression: "aprovacao.dt_analise"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data análise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data análise')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data deferimento')
    },
    attrs: {
      "uib-tooltip": "Data de deferimento"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data deferimento",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "use-utc": true,
      "format": "dd/MM/yyyy",
      "placeholder": "__/__/____"
    },
    model: {
      value: (_vm.aprovacao.dt_deferimento),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dt_deferimento", $$v)
      },
      expression: "aprovacao.dt_deferimento"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data deferimento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data deferimento')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "name": "data assinatura",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "use-utc": true,
      "format": "dd/MM/yyyy",
      "placeholder": "__/__/____"
    },
    model: {
      value: (_vm.aprovacao.dt_assinatura_convenio),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dt_assinatura_convenio", $$v)
      },
      expression: "aprovacao.dt_assinatura_convenio"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data assinatura')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data assinatura')))]) : _vm._e()])]), _vm._v(" "), _c('dl', [_c('div', {
    staticClass: "form-group col-md-12 required-field"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data vigência",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "use-utc": true,
      "format": "dd/MM/yyyy",
      "placeholder": "__/__/____"
    },
    model: {
      value: (_vm.aprovacao.dt_data_vigencia),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dt_data_vigencia", $$v)
      },
      expression: "aprovacao.dt_data_vigencia"
    }
  }), _vm._v(" "), (_vm.errors.first('data vigência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data vigência')))]) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.analise.documentDraft,
      "documentTypes": _vm.requiredFormalizationDocumentsType,
      "documentosObrigatorios": _vm.documentosObrigatorios
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('enviaEmail')
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.enviaEmail),
      expression: "aprovacao.enviaEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "enviaEmail",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.enviaEmail, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "enviaEmail", "true")
      }
    }
  }), _vm._v("\n                      Sim\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.enviaEmail),
      expression: "aprovacao.enviaEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "enviaEmail",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.enviaEmail, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "enviaEmail", "false")
      }
    }
  }), _vm._v("\n                      Não\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('enviaEmail')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('enviaEmail')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Documentos de formalização")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.aprovacao.documents,
      "documentTypes": _vm.requiredFormalizationDocumentsType,
      "documentosObrigatorios": _vm.documentosObrigatorios
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('actionApproval')
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "APROVAR"
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "APROVAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "APROVAR")
      }
    }
  }), _vm._v("\n                      Aprovar o projeto\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "ENVIAR_CONVENIO"
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "ENVIAR_CONVENIO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "ENVIAR_CONVENIO")
      }
    }
  }), _vm._v("\n                      Enviar Convênio\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "REJEITAR",
      "id": "msgDef"
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "REJEITAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "REJEITAR")
      }
    }
  }), _vm._v("\n                      Retornar para análise\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "CANCELAR"
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "CANCELAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "CANCELAR")
      }
    }
  }), _vm._v("\n                      Cancelar o projeto\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('actionApproval')))]) : _vm._e()]), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'REJEITAR' || _vm.aprovacao.resultadoAprovacao === 'CANCELAR') ? _c('div', {
    staticClass: "form-group full",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justify"
    }
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.justificativa),
      expression: "aprovacao.justificativa"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justify"
    },
    domProps: {
      "value": (_vm.aprovacao.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aprovacao, "justificativa", $event.target.value)
      }
    }
  })]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Agência condutora do projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Minuta / Plano de Trabalho")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Envio de E-mail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "col",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Deseja enviar e-mail para entidade?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Aprovação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "col",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Decisões:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8929ecb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/aprovacao_OLD.vue
// module id = 2035
// module chunks = 1